import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FilterTemplateDirective } from './filter-template.directive';
import { ColumnTemplateDirective } from './column-template.directive';
import { CommandColumnTemplateDirective } from './command-column-template.directive';
import { GroupColumnHeaderTemplateDirective } from './group-header-column-template.directive';
import { HeaderTemplateDirective } from './header-template.directive';
import { DisableMouseWheelDirective } from './disable-mouse-wheel.directive';

@NgModule({
  declarations: [
    FilterTemplateDirective,
    ColumnTemplateDirective,
    CommandColumnTemplateDirective,
    GroupColumnHeaderTemplateDirective,
    HeaderTemplateDirective,
    DisableMouseWheelDirective,
  ],
  imports: [CommonModule],
  exports: [
    FilterTemplateDirective,
    ColumnTemplateDirective,
    CommandColumnTemplateDirective,
    GroupColumnHeaderTemplateDirective,
    HeaderTemplateDirective,
    DisableMouseWheelDirective,
  ],
})
export class DirectiveModule {}
